import {Component, Input, OnInit} from '@angular/core';
import {ProgressSpinnerModule} from 'primeng/progressspinner';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {

    @Input()
    visible = false;

    constructor() {
    }

    ngOnInit(): void {
    }

}
